import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactElement } from 'react';
import { cn } from '#cn';
type TextButtonProps = ComponentProps<'button'>;

/**
 * The underlined text affordance for a tertiary action – a tier below `Button`'s pill, for
 * something like "Back" or "Resend code" sitting beside a primary CTA.
 *
 * `Button` cannot serve this: its base is a pill (`rounded-full`, uppercase, fixed height) and
 * every variant adds a fill or a border, so the closest one would turn a text link into a button
 * and flatten the hierarchy.
 *
 * There is deliberately no link form, and no `buildTextButtonClassName` extracted for one to wear.
 *
 * The hub's underlined anchors are a different affordance: an inline link inherits the size and
 * tone of the copy it sits in, and a back link underlines only on hover.
 *
 * `text-fg` is wrong for either on an inverse surface, where it renders black on near-black.
 *
 * Defaults to `type="button"`, so dropping one into a form does not submit it by accident.
 */
export const TextButton = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      type: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const type = t1 === undefined ? "button" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("text-sm text-fg underline underline-offset-4 disabled:no-underline disabled:opacity-60", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2 || $[8] !== type) {
    t3 = <button type={type} className={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = type;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};